import React from 'react'
import { Link } from 'react-router-dom'
import { Parallax } from 'react-scroll-parallax';
import RATM from '~/assets/radio-against-the-machine';
const RadiothonBanner = () => (
  <div className="radiothon-2024 banner">
      <div className="cloud"></div>

    <div className="arch">
      <div className="tower"></div>
      <div className="zedtext"></div>
      <div className="clothesline">
        <div className="test" style={{ position: 'relative', top: '75vw'}}>
          community 
        </div>
        <div className="test"  style={{ position: 'relative', top: '71vw', left: '-22.9vw' }}>
          sounds 
        </div>
        <div className="test" style={{ position: 'relative', top: '67vw', left: '14vw' }}>
          different 
        </div>
      </div>
      <div className="logos"></div>
    </div>
    <div className="byline">Woven by radio waves, cool in summer, warm in winter, locally made and 100% independent.</div>
    
    <div className="radiothon-2024-text" />

    <a href="https://support.4zzz.org.au" alt="subscribe"><div className="radiothon-2024-subscribe" ></div></a>



    <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
      <defs>
        <filter id="squiggly-0">
          <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="0"/>
          <feDisplacementMap id="displacement" in="SourceGraphic" in2="noise" scale="6" />
        </filter>

        <filter id="squiggly-1">
          <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="1"/>
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="8" />
        </filter>
        
        <filter id="squiggly-2">
          <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="2"/>
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="6" />
        </filter>

        <filter id="squiggly-3">
          <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="3"/>
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="8" />
        </filter>
        
        <filter id="squiggly-4">
          <feTurbulence id="turbulence" baseFrequency="0.02" numOctaves="3" result="noise" seed="4"/>
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="6" />
        </filter>
      </defs> 
    </svg>


    <div className="test" style={{ textShadow: '5px 5px #94ABC9' }}>
      radiothon 2024
    </div>

    <div className='margin'>
      <p style={{ fontSize: '2.5em' }} >4ZZZ sounds different because it is community coming together all in one place. Unique, passionate, proudly independent local sounds you won't hear anywhere else.</p>

      <p style={{ fontSize: '1.5em' }} >If you haven’t <a target="_blank" href="https://support.4zzz.org.au">subscribed</a> yet, hopefully this gives you a reason to join the 4ZZZ family.</p>

      <p style={{ fontSize: '1.5em' }} >If you have already subscribed, donated or bought some merch this Radiothon, thank you so much for supporting 4ZZZ. We couldn’t do this without you!</p>
      
    </div>

    


    <div className="test" style={{ textShadow: '5px 5px #94ABC9' }}>
      prizes
    </div>

  </div>
)

export default RadiothonBanner
